import ShopPaymentResourcePagingResultModel from '../../generated/types/model/resource/ShopPaymentResourcePagingResultModel';

export default class ShopPaymentResourcePagingResultViewModel extends ShopPaymentResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
